const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "";

export const apiFetch = async (path, options = {}) => {
  const base = API_BASE_URL ? API_BASE_URL.replace(/\/+$/, "") : "";
  const url = base && path.startsWith("/")
    ? `${base}${path}`
    : base
      ? `${base}/${path}`
      : path;
  const init = {
    method: options.method || "GET",
    credentials: "include",
    headers: { ...(options.headers || {}) },
  };

  if (options.body !== undefined) {
    if (options.body instanceof FormData) {
      init.body = options.body;
    } else {
      init.body = JSON.stringify(options.body);
      if (!init.headers["Content-Type"]) {
        init.headers["Content-Type"] = "application/json";
      }
    }
  }

  const response = await fetch(url, init);
  const text = await response.text();
  let payload = null;
  try {
    payload = text ? JSON.parse(text) : null;
  } catch (error) {
    payload = null;
  }
  if (!response.ok) {
    const rawMessage =
      payload?.error ||
      payload?.message ||
      payload?.detail ||
      text ||
      "Request failed";
    if (response.status === 401 && typeof window !== "undefined") {
      window.dispatchEvent(new CustomEvent("auth:unauthorized"));
    }
    const message =
      response.status === 401
        ? "Session expired. Please sign in again."
        : rawMessage;
    const err = new Error(message);
    err.status = response.status;
    err.statusText = response.statusText;
    err.url = url;
    err.method = init.method;
    err.payload = payload;
    err.responseText = text;
    throw err;
  }
  return payload;
};
